import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { CircularProgress, Button } from "@material-ui/core";
import * as Yup from "yup";
import { KTUtil } from "./../../../../_metronic/_assets/js/components/util.js";
import { injectIntl } from "react-intl";
import Swal from "sweetalert2";
import { API_URL } from "../../../../constants";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { onAxiosApiCall, getLanguage } from "../../../../utils";
import styles from "./forgotpassword.module.scss";
const initialValues = {
  email: "",
};

function ForgotPassword(props) {
  var language = getLanguage(navigator.language);
  // client panel content
  const [clientPanelContent, setClientPanelContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const history = useHistory();

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(clientPanelContent.wrong_email_txt)
      .min(3, clientPanelContent.min_three_txt_error)
      .max(50, clientPanelContent.max_no_txt_error)
      .required(clientPanelContent.email_required),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  useEffect(() => {
    getClientPanelContent();
  }, []);

  // get client panel contents
  const getClientPanelContent = () => {
    const section = "forgotpass_screen";
    onAxiosApiCall(
      API_URL + language + "/get-client-panel-content/" + section,
      "GET",
      ""
    ).then((response) => {
      if (response.data !== undefined && response.data !== "") {
        setClientPanelContent(response.data[section]);
      } else {
        setClientPanelContent("");
      }
    });
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setSubmitting }) => {
      setTimeout(() => {
        setLoading(true);
        setDisabled(true);
        onAxiosApiCall(API_URL + "forgot-password", "POST", values)
          .then((response) => {
            if (response.status === 200) {
              setSubmitting(false);
              setLoading(false);
              setDisabled(false);
              Swal.fire({
                title:
                  clientPanelContent[response.success_key] !== undefined
                    ? clientPanelContent[response.success_key]
                    : "",
                text: "",
                icon: "success",
                width: 600,
              });
              setTimeout(() => {
                history.push("/login");
              }, 200);
            } else {
              setLoading(false);
              setDisabled(false);
              Swal.fire(
                clientPanelContent[response.error_key] !== undefined
                  ? clientPanelContent[response.error_key]
                  : "",
                "",
                "error"
              );
            }
          })
          .catch((error) => {
            console.log("error", error);
            setLoading(false);
            setDisabled(false);
          });
      }, 500);
    },
  });
  return (
    <>
      <div
        className={`login login-3 wizard d-flex flex-column flex-lg-row h-100 w-100 ${
          KTUtil.isMobileDevice() ? "mobile-login" : "flex-column-fluid"
        }`}
      >
        <div
          className={`login-aside flex-column flex-center flex-row-auto ${styles.loginRoot} `}
        >
          <div
            className={`d-flex justify-content-start align-items-center h-100 px-10`}
          >
            <div className={`${styles.leftsideTextDiv}`}>
              <div className="d-flex mb-10">
                <img
                  src={toAbsoluteUrl("/media/logos/white-logo.png")}
                  className={`w-230px ${styles.desktopLogo}`}
                  alt=""
                />
              </div>
              <h2
                className={`font-weight-bolder ${styles.welcomBackText}`}
                dangerouslySetInnerHTML={{
                  __html:
                    clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.page_title !== undefined &&
                    clientPanelContent.page_title !== ""
                      ? clientPanelContent.page_title
                      : "Welcome Back to <br />Youshow",
                }}
              ></h2>
              <div className={`${styles.separator}`}></div>
              <h4
                className={`font-weight-bolder ${styles.subtext}`}
                dangerouslySetInnerHTML={{
                  __html:
                    clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.sub_title !== undefined &&
                    clientPanelContent.sub_title !== ""
                      ? clientPanelContent.sub_title
                      : "Sign in to continue to your account.",
                }}
              ></h4>
            </div>
          </div>

          {/* <div className="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-x-center" style="background-position-y: calc(100% + 5rem); background-image: url(assets/media/svg/illustrations/login-visual-5.svg)"></div> */}
        </div>
        <div
          className={`login-content flex-row-fluid d-flex flex-column p-10 `}
        >
          <div className="d-flex flex-row-fluid flex-center">
            <div className="login-form">
              <div className="d-flex flex-center mb-15">
                <img
                  src={toAbsoluteUrl("/media/logos/white-logo.png")}
                  className={`w-250px ${styles.mobileLogo}`}
                  alt=""
                />
              </div>
              <div className="login-signin">
                <div className="text-center mb-10 mb-lg-20">
                  {/* <h3 className="font-size-h1">
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.page_title !== undefined &&
                    clientPanelContent.page_title !== ""
                      ? clientPanelContent.page_title
                      : ""}
                  </h3> */}
                  {/* <div className="text-muted font-weight-bold">
                  {clientPanelContent !== undefined && clientPanelContent !== "" && clientPanelContent.sub_title !== undefined && clientPanelContent.sub_title !== "" ? clientPanelContent.sub_title : ""}
                </div> */}
                </div>
                <form
                  onSubmit={formik.handleSubmit}
                  className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
                >
                  {formik.status && (
                    <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                      <div className="alert-text font-weight-bold">
                        {formik.status}
                      </div>
                    </div>
                  )}
                  <div className={`form-group fv-plugins-icon-container ${styles.formControl}`}>
                    <input
                      placeholder={
                        clientPanelContent !== undefined &&
                        clientPanelContent !== "" &&
                        clientPanelContent.email_txt !== undefined &&
                        clientPanelContent.email_txt !== ""
                          ? clientPanelContent.email_txt
                          : ""
                      }
                      type="email"
                      className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                        "email"
                      )}`}
                      name="email"
                      {...formik.getFieldProps("email")}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.email}
                        </div>
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group w-100">
                    <Button
                      type="submit"
                      id="kt_login_forgot_submit"
                      className={`w-100 ${styles.submitBtn}`}
                      disabled={disabled}
                    >
                      {clientPanelContent !== undefined &&
                      clientPanelContent !== "" &&
                      clientPanelContent.send_link_txt !== undefined &&
                      clientPanelContent.send_link_txt !== ""
                        ? clientPanelContent.send_link_txt
                        : ""}
                      {loading && (
                        <CircularProgress
                          size="1.5rem"
                          color="#fff"
                          className="ml-2"
                        />
                      )}
                    </Button>
                  </div>
                </form>
                <div className={`form-group d-flex flex-wrap flex-center ${styles.backtoLogin}`}>
                  <Link to="/login">
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.back_to_login_txt !== undefined &&
                    clientPanelContent.back_to_login_txt !== ""
                      ? clientPanelContent.back_to_login_txt
                      : ""}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default injectIntl(ForgotPassword);
